<template>
  <div class="the-header-center">
    <div class="header-info" style="background-color: #e5e5e5">
      <div class="header-logo">
        <img src="@/assets/images/logo-250x70.png">
      </div>
      <div style="color: #000" class="user-balance" v-if="balanceShow && balanceText != null">积分余额：{{balanceText}}</div>
    </div>
    <div class="header-space"></div>
  </div>
</template>

<script>
  import { Cell } from 'mint-ui';

  export default {
    name: 'TheHeaderCenter',
    props: {
      balance: Number,
      balanceShow: Boolean,
    },
    data () {
      return {
        balanceText: null
      }
    },
    computed: {
    },
    components: {
      [Cell.name]:Cell
    },
    watch: {
    },
    mounted () {
      this.pageInit()
    },
    methods: {
      pageInit() {
        if (this.balance == null) {
          if (this.balanceShow == true) {
            this.getBalance();
          }
        } else {
          this.balanceText = this.balance
        }
      },
      // 取得余额
      getBalance () {
        let params = {}
        this.$api.user.getBalance(params).then((res) => {
          if (res.data.code == 1) {
            this.balanceText = res.data.data
          }
        }).catch(err => {
          console.log(err)
        })
      }
    }
  };
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/css/my-mint.scss";
  @import "@/assets/css/style.scss";
</style>
